import _defineProperty from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _slicedToArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { isImmutable, denormalizeImmutable } from "./ImmutableUtils.js";

var _normalize = function normalize(schema, input, parent, key, visit, addEntity, visitedEntities) {
  var object = _objectSpread({}, input);

  Object.keys(schema).forEach(function (key) {
    var localSchema = schema[key];
    var value = visit(input[key], input, key, localSchema, addEntity, visitedEntities);

    if (value === undefined || value === null) {
      delete object[key];
    } else {
      object[key] = value;
    }
  });
  return object;
};

export { _normalize as normalize };

var _denormalize = function denormalize(schema, input, unvisit) {
  if (isImmutable(input)) {
    return denormalizeImmutable(schema, input, unvisit);
  }

  var object = _objectSpread({}, input);

  var found = true;
  var deleted = false;
  Object.keys(schema).forEach(function (key) {
    var _unvisit = unvisit(object[key], schema[key]),
        _unvisit2 = _slicedToArray(_unvisit, 3),
        item = _unvisit2[0],
        foundItem = _unvisit2[1],
        deletedItem = _unvisit2[2];

    if (object[key] !== undefined) {
      object[key] = item;
    }

    if (deletedItem) {
      deleted = true;
    }

    if (!foundItem) {
      found = false;
    }
  });
  return [object, found, deleted];
};

export { _denormalize as denormalize };

function _infer(schema, args, indexes, recurse) {
  var resultObject = {};

  for (var _i = 0, _Object$keys = Object.keys(schema); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    resultObject[k] = recurse(schema[k], args, indexes);
  }

  return resultObject;
}
/**
 * Represents fixed objects
 * @see https://resthooks.io/docs/api/Object
 */


export { _infer as infer };

var ObjectSchema = /*#__PURE__*/function () {
  function ObjectSchema(definition) {
    _classCallCheck(this, ObjectSchema);

    this.schema = void 0;
    this.define(definition);
  }

  _createClass(ObjectSchema, [{
    key: "define",
    value: function define(definition) {
      this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
        var schema = definition[key];
        return _objectSpread(_objectSpread({}, entitySchema), {}, _defineProperty({}, key, schema));
      }, this.schema || {});
    }
  }, {
    key: "normalize",
    value: function normalize() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _normalize.apply(void 0, [this.schema].concat(args));
    }
  }, {
    key: "denormalize",
    value: function denormalize() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _denormalize.apply(void 0, [this.schema].concat(args));
    }
  }, {
    key: "infer",
    value: function infer(args, indexes, recurse) {
      return _infer(this.schema, args, indexes, recurse);
    }
  }]);

  return ObjectSchema;
}();

export { ObjectSchema as default };